module.exports = __webpack_public_path__ + "img/DMG_logo.a6b2bff3.png";